import React from 'react';
import './EmployeeCard.scss';

const EmployeeCard = ({ employee, onKnowMore }) => {
  const { name, img, designation, empID } = employee;

  // Use name or fallback options
  const displayName = name || employee.displayName || 'Unknown';
  
  // Get first letter for avatar
  const avatarInitial = displayName.charAt(0).toUpperCase();

  return (
    <div className="employee-card">
      <div className="employee-image">
        {img ? (
          <img src={img} alt={displayName} className="profile-image" />
        ) : (
          <div className="avatar-placeholder">
            {avatarInitial}
          </div>
        )}
      </div>
      <div className="employee-info">
        <h3>{displayName}</h3>
        {designation && <p className="designation">{designation}</p>}
        {empID && <p className="employee-id">{empID}</p>}
        <button 
          className="know-more-btn"
          onClick={onKnowMore}
        >
          Know More
        </button>
      </div>
    </div>
  );
};

export default EmployeeCard; 